import React from 'react';
import { Modal, Button } from '@ezviz/ezd';
import dclog from '../../common/utils/dclog';
import './index.less'

// 邮箱提示弹框
// 通过isShow字段控制页面同时只能展示一个此弹框
const MailModal = (props) => {
  const {changeModal, title = '线下汇款'} = props;
  return(
    <Modal
        title={title}
        visible={props.isShow}
        onOk={()=>changeModal(false)}
        onCancel={()=>changeModal(false)}
        footer={[
          <Button key="back" type="primary" onClick={()=>changeModal(false)} style={{marginBottom:24}}>
            我知道了
          </Button>
        ]}
        centered
        destroyOnClose
        maskClosable={false}
        className="mail-modal"
      >
        <div>
            <p style={{marginBottom: 0}}>若有对公充值、合同签订等需要，请联系我们<a
              style={{ display: 'inline-block' }}
              className="colsub"
              href="mailto:open-team@ezvizlife.com?subject=联系商务&body=您好，请留下您的疑虑，我们将尽快联系您!%0A手机联系方式：%0A萤石开放平台账号：%0A对计费项的疑问：%0A希望解决的问题："
              onClick={
                () => {
                  dclog({
                    systemName: 'open_web_btn_action',
                    bn: 18,
                    action: 0,
                    un: true,
                    extra: `&page=${window.location.pathname}&text=联系商务&href=open-team@ezvizlife.com`
                  })
                }
              }
            >
              <div className="single">open-team@ezvizlife.com</div>
            </a>(点击邮箱链接获取邮件模板)</p>
          </div>
      </Modal>
  )
}
export default MailModal;

